<template>
  <fragment>
    <div class="v2_font_Montserrat font_size_750rem navigation-tabs">
      <b-nav tabs justified>
        <b-row>
          <b-col lg="3" md="3" cols="6" class="px-0 border-nav">
            <b-nav-item to="/user/dashboard" exact>
              <span class="d-flex align-items-center">
                <img :src="getImgUrl('dashboard-icon.svg')" class="mr-2" />
                <span>Dashboard</span>
              </span>
            </b-nav-item>
          </b-col>
          <b-col lg="3" md="3" cols="6" class="px-0 border-nav">
            <b-nav-item to="/user/surveyHome" exact>
              <span class="d-flex align-items-center">
                <img :src="getImgUrl('share-icon.svg')" class="mr-2" />
                <span>Share</span>
              </span>
            </b-nav-item>
          </b-col>
          <b-col lg="3" md="3" cols="6" class="px-0 border-nav">
            <b-nav-item to="/user/filters" exact>
              <span class="d-flex align-items-center">
                <img :src="getImgUrl('inform-icon.svg')" class="mr-2" />
                <span>Inform</span>
              </span>
            </b-nav-item>
          </b-col>
          <b-col lg="3" md="3" cols="6" class="px-0">
            <b-nav-item to="/user/exchange" exact>
              <span class="d-flex align-items-center">
                <img :src="getImgUrl('connect-icon.svg')" class="mr-2" />
                <span>Connect</span>
              </span>
            </b-nav-item>
          </b-col>
        </b-row>
      </b-nav>
    </div>
  </fragment>
</template>

<script>
import ImageUrlMixin from '@/mixins/ImageUrlMixin';
export default {
  name: 'UserNavMenuItems',
  mixins: [ImageUrlMixin],
};
</script>

<style scoped>
.navigation-tabs{
  padding: 0 15px;
}
.navigation-tabs .nav{
  display: unset;
}
.border-nav{
  border-right: 1px solid rgba(3,23,36,0.2);
}
@media screen and (max-width: 768px) {
    .border-nav {
        border: none !important;
    }
}
</style>

<style scoped lang="scss">
@import '../../../../sass/v2';
.nav-tabs {
  .nav-item {
    .nav-link {
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 15px;
      height: 50px;
      background-color: $phairify_v2_color_alice_blue;
      text-transform: uppercase;
      letter-spacing: 1.4px;
      color: $phairify_v2_color_black_knight;
      border: 0;
      border-radius: 0;
      border-right: 1px solid rgba(#031724, 0.2);
      &:hover {
        border-right: 1px solid rgba(#031724, 0.2);
      }
      &.router-link-exact-active {
        background: #ffffff 0% 0% no-repeat padding-box;
        border-right: 1px solid rgba(#031724, 0.2);
      }
    }
    &:last-child {
      .nav-link {
        border-right: 0;
      }
    }
  }
}
</style>
